import React, {useEffect, useState} from "react";
import {Card, Checkbox, Col, Divider, Image, Popconfirm, Row} from "antd";
import Link from "antd/es/typography/Link";
import {DeleteOutlined, EditOutlined, SelectOutlined} from "@ant-design/icons";
import PropTypes from "prop-types";
import {sanity_s3_url_display} from "../Utils";

const {Meta} = Card

function GalleryViewCard(props) {
    const [deleteConfirmShow, setDeleteConfirmShow] = useState(false)
    const [checked, setChecked] = useState(false)
    useEffect(() => {
        setChecked(props.checked)
    }, [props.checked])

    let url = props.url || props.s3_url || props.static_url

    let imgStyle = {maxHeight: 640}
    let preview = false

    if (props.aspectRatioKey && props.aspectRatioKey !== '1') {
        let aspectRatio = ''
        if (props.aspectRatioKey === '2') aspectRatio = '1'
        if (props.aspectRatioKey === '3') aspectRatio = '3/2'
        if (props.aspectRatioKey === '4') aspectRatio = '16/9'
        imgStyle = {
            objectFit: 'scale-down',
            aspectRatio: aspectRatio,
            marginLeft: 'auto', marginRight: 'auto',
            width: '100%', height: undefined,
        }
    }

   preview = {
        src: sanity_s3_url_display(props.url) || sanity_s3_url_display(props.s3_url) ||
            sanity_s3_url_display(props.static_url)
    }

    let cover = (url) ? (
        <Image
            src={sanity_s3_url_display(props.url) || sanity_s3_url_display(props.static_url) ||
                sanity_s3_url_display(props.s3_url)}
            preview={preview}
            alt={props.name || props.title}
            style={imgStyle}
        />
    ) : (
        props.imagePlaceholder
    )

    return (
        <Col xs={props.xs} sm={props.sm} md={props.md} lg={props.lg}
             key={'GalleryViewCard_' + (url ?? (props.id ?? ""))}>
            <Card
                loading={props.loading}
                style={{
                    marginBottom: '18px',
                }}
                cover={!props.loading && <div>
                    <Checkbox style={{position: "absolute", top: 4, left: 4, zIndex: 300}}
                              checked={checked}
                              onChange={(e) => {
                                  props.onCheckChange(e.target.checked, props.element)
                              }}>
                    </Checkbox>
                    <div style={{display: 'flex', width: '100%'}}>
                        {cover}
                    </div>
                </div>}
                actions={[
                    props.editUrl ? (
                        <Link style={{color: ' #0531ad'}} href={props.editUrl}>
                            <EditOutlined style={{fontSize: 16}}/>
                        </Link>
                    ) : null,
                    props.openUrl ? (
                        <Link
                            key={'open_' + props.id}
                            style={{color: ' #0531ad'}}
                            href={props.openUrl}
                            target={'_blank'}
                            rel={'noreferrer'}
                        >
                            {' '}
                            <SelectOutlined rotate={90}/>
                        </Link>
                    ) : null,
                    props.deleteFunc ? (
                        <Popconfirm
                            open={deleteConfirmShow}
                            key={props.id}
                            title='Are you sure you want to permanently delete it?'
                            onConfirm={() => {
                                props.deleteFunc(props.id);
                                setDeleteConfirmShow(false)
                            }}
                            onCancel={() => {
                                setDeleteConfirmShow(false)
                            }}
                        >
                            <Link style={{color: 'indianred'}}>
                                <DeleteOutlined
                                    onClick={() => {
                                        setDeleteConfirmShow(true)
                                    }}
                                />
                            </Link>
                        </Popconfirm>
                    ) : null
                ]}
            >
                <Row justify='space-between' align='middle'>
                    <Meta
                        title={
                            <div style={{width: '100%', padding: 4, height: 66, textOverflow: 'ellipsis'}}>
                                <span
                                    style={{
                                        display: 'block',
                                        fontSize: 12,
                                        width: '100%'
                                    }}
                                >
                                  {'# ' + props.id}
                                </span>
                                <Divider style={{padding: 0, margin: 4}}/>
                                <a
                                    target={'_blank'}
                                    style={{
                                        overflowWrap: 'anywhere',
                                        fontSize: 14,
                                        maxWidth: '80%'
                                    }}
                                    rel='noreferrer'
                                    href={props.openUrl}
                                >
                                    {' '}
                                    {props.name || props.title}
                                </a>
                            </div>
                        }
                    />
                </Row>
            </Card>
        </Col>
    )
}

GalleryViewCard.defaultProps = {
    xs: 12,
    sm: 8,
    md: 6,
    lg: 6,
    checked: false,
    onCheckChange: null,
    aspectRatioKey: ''
}

GalleryViewCard.propTypes = {
    xs: PropTypes.number,
    sm: PropTypes.number,
    md: PropTypes.number,
    lg: PropTypes.number,
    index: PropTypes.number,
    id: PropTypes.number,
    name: PropTypes.string,
    title: PropTypes.string,
    loading: PropTypes.bool,
    cover: PropTypes.object,
    editUrl: PropTypes.string,
    openUrl: PropTypes.string,
    deleteFunc: PropTypes.func,
    checked: PropTypes.bool,
    onCheckChange: PropTypes.func,
    aspectRatioKey: PropTypes.string,
}

export default GalleryViewCard